<template>
    <svg class="spinner-scale" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
        <g class="spinner_OSmW">
            <rect height="6" opacity=".14" style="fill:rgba(224,224,224)" width="2" x="11" y="1"/>
            <rect height="6" opacity=".29" style="fill:rgb(224,224,224)" transform="rotate(30 12 12)" width="2"
                  x="11"
                  y="1"/>
            <rect height="6" opacity=".43" style="fill:rgb(224,224,224)" transform="rotate(60 12 12)" width="2"
                  x="11"
                  y="1"/>
            <rect height="6" opacity=".57" style="fill:rgb(224,224,224)" transform="rotate(90 12 12)" width="2"
                  x="11"
                  y="1"/>
            <rect height="6" opacity=".71" style="fill:rgb(224,224,224)" transform="rotate(120 12 12)" width="2"
                  x="11" y="1"/>
            <rect height="6" opacity=".86" style="fill:rgb(224,224,224)" transform="rotate(150 12 12)" width="2"
                  x="11" y="1"/>
            <rect height="6" style="fill:rgb(224,224,224)" transform="rotate(180 12 12)" width="2" x="11" y="1"/>
        </g>
    </svg>
</template>

<script>
export default {
    name: 'Spinner',
};
</script>

<style scoped>
.spinner-scale {
    transform: scale(0.9);
}

.spinner_OSmW {
    transform-origin: center;
    animation: spinner_T6mA 1s step-end infinite
}

@keyframes spinner_T6mA {
    8.3% {
        transform: rotate(30deg)
    }
    16.6% {
        transform: rotate(60deg)
    }
    25% {
        transform: rotate(90deg)
    }
    33.3% {
        transform: rotate(120deg)
    }
    41.6% {
        transform: rotate(150deg)
    }
    50% {
        transform: rotate(180deg)
    }
    58.3% {
        transform: rotate(210deg)
    }
    66.6% {
        transform: rotate(224deg)
    }
    75% {
        transform: rotate(270deg)
    }
    83.3% {
        transform: rotate(300deg)
    }
    91.6% {
        transform: rotate(330deg)
    }
    100% {
        transform: rotate(360deg)
    }
}
</style>
